import React from "react";
const AlphaherdSectionImgCard = ({ img, animDir }) => {
  return (
    <>
      <div
        className="card_img"
        data-aos={animDir}
        data-aos-delay="500"
        data-aos-duration="5000"
        data-aos-once="true"
        data-aos-easing="ease-in-out"
      >
        <div className="image_bg">
          <div className="img_wrapper">
            <img
              src={img}
              alt="img"
              data-aos={animDir}
              data-aos-delay="1000"
              data-aos-duration="5000"
              data-aos-once="true"
              data-aos-easing="ease-in-out"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AlphaherdSectionImgCard;
